<template>
  <div class="tips__container">
    <aside class="tips__side" :class="{'tips__side--show': show_sidebar}">
      <nav class="tips__nav">
        <div class="tips__side-title">
          <img src="@/assets/img/tips/tips-list.svg" alt="List">
          <span>Блок навигации</span>
        </div>
        <ul class="tips__nav-list">
          <li>
            <a @click.prevent="onScrollToSection('section-1')" href="#section-1" class="tips__nav-link tips__nav-link--active">
              <div class="tips__nav-icon">
                <img src="@/assets/img/tips/tips-personal-icon.svg" alt="Icon">
              </div>
              Личный кабинет на портале Altezza Travel
            </a>
          </li>
          <li>
            <a @click.prevent="onScrollToSection('section-2')" href="#section-2" class="tips__nav-link">
              <div class="tips__nav-icon">
                <img src="@/assets/img/tips/tips-gear-icon.svg" alt="Icon">
              </div>
              Экипировка для восхождения
            </a>
          </li>
          <li>
            <a @click.prevent="onScrollToSection('section-3')" href="#section-3" class="tips__nav-link">
              <div class="tips__nav-icon">
                <img src="@/assets/img/tips/tips-packing-icon.svg" alt="Icon">
              </div>
              Как правильно сложить снаряжение
            </a>
          </li>
          <li>
            <a @click.prevent="onScrollToSection('section-4')" href="#section-4" class="tips__nav-link">
              <div class="tips__nav-icon">
                <img src="@/assets/img/tips/tips-clock-icon.svg" alt="Icon">
              </div>
              Время начала экспедиции
            </a>
          </li>
          <li>
            <a @click.prevent="onScrollToSection('section-5')" href="#section-5" class="tips__nav-link">
              <div class="tips__nav-icon">
                <img src="@/assets/img/tips/tips-luggage-icon.svg" alt="Icon">
              </div>
              Хранение багажа и ценных вещей
            </a>
          </li>
          <li>
            <a @click.prevent="onScrollToSection('section-6')" href="#section-6" class="tips__nav-link">
              <div class="tips__nav-icon">
                <img src="@/assets/img/tips/tips-support-icon.svg" alt="Icon">
              </div>
              Знакомство с гидами
            </a>
          </li>
          <li>
            <a @click.prevent="onScrollToSection('section-7')" href="#section-7" class="tips__nav-link">
              <div class="tips__nav-icon">
                <img src="@/assets/img/tips/tips-gps-icon.svg" alt="Icon">
              </div>
              Ссылка на GPS трекер
            </a>
          </li>
          <li>
            <a @click.prevent="onScrollToSection('section-8')" href="#section-8" class="tips__nav-link">
              <div class="tips__nav-icon">
                <img src="@/assets/img/tips/tips-water-icon.svg" alt="Icon">
              </div>
              Вода на Килиманджаро
            </a>
          </li>
          <li>
            <a @click.prevent="onScrollToSection('section-9')" href="#section-9" class="tips__nav-link">
              <div class="tips__nav-icon">
                <img src="@/assets/img/tips/tips-medical-icon.svg" alt="Icon">
              </div>
              Медосмотры в экспедициях Altezza Travel
            </a>
          </li>
          <li>
            <a @click.prevent="onScrollToSection('section-10')" href="#section-10" class="tips__nav-link">
              <div class="tips__nav-icon">
                <img src="@/assets/img/tips/tips-device-icon.svg" alt="Icon">
              </div>
              Телефоны, планшеты и другие гаджеты
            </a>
          </li>
          <li>
            <a @click.prevent="onScrollToSection('section-11')" href="#section-11" class="tips__nav-link">
              <div class="tips__nav-icon">
                <img src="@/assets/img/tips/tips-shower-icon.svg" alt="Icon">
              </div>
              Туалеты и души на Килиманджаро
            </a>
          </li>
          <li>
            <a @click.prevent="onScrollToSection('section-12')" href="#section-12" class="tips__nav-link">
              <div class="tips__nav-icon">
                <img src="@/assets/img/tips/tips-responsible-icon.svg" alt="Icon">
              </div>
              Как не навредить экосистеме Килиманджаро
            </a>
          </li>
          <li>
            <a @click.prevent="onScrollToSection('section-13')" href="#section-13" class="tips__nav-link">
              <div class="tips__nav-icon">
                <img src="@/assets/img/tips/tips-beginning-icon.svg" alt="Icon">
              </div>
              Начало восхождения
            </a>
          </li>
          <li>
            <a @click.prevent="onScrollToSection('section-14')" href="#section-14" class="tips__nav-link">
              <div class="tips__nav-icon">
                <img src="@/assets/img/tips/tips-mountain-icon.svg" alt="Icon">
              </div>
              Как проходит обычный день на Килиманджаро
            </a>
          </li>
          <li>
            <a @click.prevent="onScrollToSection('section-15')" href="#section-15" class="tips__nav-link">
              <div class="tips__nav-icon">
                <img src="@/assets/img/tips/tips-food-icon.svg" alt="Icon">
              </div>
              Как кормят в экспедициях Altezza Travel
            </a>
          </li>
          <li>
            <a @click.prevent="onScrollToSection('section-16')" href="#section-16" class="tips__nav-link">
              <div class="tips__nav-icon">
                <img src="@/assets/img/tips/tips-rest-icon.svg" alt="Icon">
              </div>
              О чем важно помнить в лагере
            </a>
          </li>
          <li>
            <a @click.prevent="onScrollToSection('section-17')" href="#section-17" class="tips__nav-link">
              <div class="tips__nav-icon">
                <img src="@/assets/img/tips/tips-socks-icon.svg" alt="Icon">
              </div>
              Как не замерзнуть на Килиманджаро
            </a>
          </li>
          <li>
            <a @click.prevent="onScrollToSection('section-18')" href="#section-18" class="tips__nav-link">
              <div class="tips__nav-icon">
                <img src="@/assets/img/tips/tips-night-icon.svg" alt="Icon">
              </div>
              Ночь штурма вершины
            </a>
          </li>
          <li>
            <a @click.prevent="onScrollToSection('section-19')" href="#section-19" class="tips__nav-link">
              <div class="tips__nav-icon">
                <img src="@/assets/img/tips/tips-descent-icon.svg" alt="Icon">
              </div>
              Спуск с вершины Килиманджаро
            </a>
          </li>
          <li>
            <a @click.prevent="onScrollToSection('section-20')" href="#section-20" class="tips__nav-link">
              <div class="tips__nav-icon">
                <img src="@/assets/img/tips/tips-insurance-icon.svg" alt="Icon">
              </div>
              Эвакуация и страховка
            </a>
          </li>
        </ul>
      </nav>
    </aside>
    <div class="tips__content">
      <div class="tips__head">
        <div class="tips__head-container">
          <h1 class="tips__title tips__title--mb">Восхождение на Килиманджаро</h1>
          <span>Все, что вам необходимо знать перед экспедицией</span>
        </div>
        <button @click="onShowSidebar" class="tips__burger"></button>
      </div>
      <div class="tips__wish">
        Совсем скоро начнется ваше путешествие на Килиманджаро. Мы подготовили для вас подробный гайд, который поможет как следует подготовиться к экспедиции и успешно покорить “Вершину Африки”.
        <img src="@/assets/img/tips/tips-sun.svg" alt="Sun">
      </div>
      <p class="tips__text">На ознакомление с материалом потребуется около 30-35 минут.</p>
      <p class="tips__text">Кроме того, для вашего удобства мы изложили ключевые моменты в 25-минутном видео (на английском языке).</p>
      <div class="tips__video">
        <iframe
          srcdoc="<style>
            * {
              padding: 0;
              margin: 0;
              overflow: hidden;
            }

            body, html {
              height: 100%;
            }

            a {
              display: flex;
              height: 100%;
            }

            img {
              position: absolute;
              width: 100%;
              height: 100%;
              inset: 0;
            }

            svg {
              margin: auto;
              filter: drop-shadow(1px 1px 10px hsl(206.5, 70.7%, 8%));
              transition: all 0.25s ease-in-out;
            }

            body:hover svg {
              filter: drop-shadow(1px 1px 10px hsl(206.5, 0%, 10%));
              transform: scale(1.2);
            }
          </style>
          <a href='https://www.youtube.com/embed/_MRlLpSwAro?si=dgdAO4C4Dau4evXy&autoplay=1&mute=1'>
            <img src='https://img.youtube.com/vi/_MRlLpSwAro/maxresdefault.jpg' alt='Preview'>
            <svg xmlns='http://www.w3.org/2000/svg' width='80' height='59' fill='none'><path fill='#fff' d='M21.332 8h36v42.667h-36z'/><path fill='#E60000' d='M78.13 9.985c-1.6-4.923-6.895-7.905-11.767-8.589a249.56 249.56 0 0 0-52.725 0C8.765 2.08 3.456 5.033 1.87 9.985a99.938 99.938 0 0 0 0 38.493c1.6 4.916 6.894 7.905 11.767 8.589a249.568 249.568 0 0 0 52.724 0c4.873-.684 10.182-3.637 11.767-8.59a99.937 99.937 0 0 0 0-38.492Zm-47.7 34.573v-30.66l24.958 15.33c-8.414 5.17-16.58 10.181-24.958 15.33Z'/></svg>
          </a>
        "
          class="tips__iframe"
          loading="lazy"
          src="https://www.youtube.com/embed/_MRlLpSwAro?si=dgdAO4C4Dau4evXy"
          frameborder="0"
          allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
          referrerpolicy="strict-origin-when-cross-origin"
          allowfullscreen
        ></iframe>
      </div>
      <section class="tips__section" id="section-1">
        <div class="tips__headline">
          <div class="tips__headline-picture">
            <img src="@/assets/img/tips/tips-personal.svg" alt="Personal">
          </div>
          <h2 class="tips__title">Личный кабинет на портале Altezza Travel</h2>
        </div>
        <p class="tips__text">
          В нем нужно будет указать ваше имя, информацию о прибытии, диетические предпочтения, а также заполнить медицинскую форму.
        </p>
        <div class="tips__text">
          На основе этих данных мы организуем встречу в аэропорту и подготовим подходящее для вас меню на время экспедиции. Пожалуйста, постарайтесь ответить на вопросы за одну-две недели до вылета в Танзанию.
        </div>
      </section>
      <section class="tips__section" id="section-2">
        <div class="tips__headline">
          <div class="tips__headline-picture">
            <img src="@/assets/img/tips/tips-gear.svg" alt="Gear">
          </div>
          <h2 class="tips__title">Экипировка для восхождения</h2>
        </div>
        <div class="tips__gear">
          <div class="tips__gear-img"></div>
          <div class="tips__gear-content">
            <span class="tips__gear-title">Список снаряжения для Килиманджаро в формате PDF</span>
            <span class="tips__gear-text">Подробное описание всего, что понадобится на восхождении</span>
            <a href="https://altezzatravel.ru/kilimanjaro-packing-list.pdf" target="_blank" class="tips__gear-link">
              ПОЛУЧИТЬ PDF
            </a>
          </div>
        </div>
        <p class="tips__text">
          Чтобы убедиться, что ваше снаряжение подходит для восхождения, сотрудник Altezza Travel обязательно проверит его перед началом экспедиции.
        </p>
        <p class="tips__text">
          Спальные мешки, теплые куртки для штурма вершины и треккинговые палки занимают много места и могут не поместиться в чемодан. Кроме того, если Килиманджаро – ваше первое восхождение, то покупка полного комплекта снаряжения существенно отразится на бюджете путешествия. Чтобы избежать лишних расходов, вы можете арендовать все необходимое у нас по прилете. У Altezza Travel всегда в наличии качественная экипировка от The North Face, Black Diamond, Mountain Hardwear, Marmot, Zamberlan и других брендов.
        </p>
        <p class="tips__text">
          Удобнее всего оформить аренду через личный кабинет на нашем портале. Отметьте необходимое снаряжение, и менеджер Altezza Travel доставит его на брифинг перед восхождением.
        </p>
      </section>
      <section class="tips__section" id="section-3">
        <div class="tips__headline">
          <div class="tips__headline-picture">
            <img src="@/assets/img/tips/tips-packing.svg" alt="Packing">
          </div>
          <h2 class="tips__title">Как правильно сложить снаряжение</h2>
        </div>
        <p class="tips__text">Экипировку для восхождения необходимо разделить на две части: вещи, которые вы положите в свой рюкзак, и снаряжение, которое в бауле понесет портер.</p>
        <h3 class="tips__title">Что положить в рюкзак</h3>
        <p class="tips__text">
          Выбирая рюкзак для восхождения, рассматривайте модели объемом 30-40 литров с поясным ремнем и накидкой от дождя. Такие также доступны для аренды в Altezza Travel.
        </p>
        <p class="tips__text">
          В рюкзак необходимо положить все, что должно быть под рукой на переходах между лагерями. Это фляжка с водой или питьевая система, флисовая кофта, ветрозащитная куртка и штаны, солнцезащитные очки и крем, бейсболка или шляпа с широкими полями, бафф, гетры, влажные салфетки и пакеты для мусора. Подробнее об этом мы рассказывали материале о
          <a href="https://altezzatravel.ru/climbing-kilimanjaro/packing-list" target="_blank">снаряжении для треккинга на Килиманджаро</a>.
        </p>
        <p class="tips__text">
          Треккинговые палки можно закрепить специальными лямками сбоку рюкзака. Вы будете их использовать с первого и до последнего дня экспедиции.
        </p>
        <p class="tips__text">
          Ежедневные переходы в среднем будут длиться 4-6 часов. Если вы устанете нести рюкзак, сообщите об этом гидам. Они либо заберут его у вас, либо переложат самые тяжелые вещи на время к себе, предоставив вам возможность восстановить силы.
        </p>
        <div class="tips__note">
          <div class="tips__note-title">Ваш рюкзак может понести дополнительный портер</div>
          <p class="tips__note-text">
            Если вы не хотите нести рюкзак самостоятельно, можете нанять портера. Он будет идти поблизости, чтобы у вас всегда был доступ к своим вещам. Мы рекомендуем этот вариант тем, у кого есть проблемы со спиной или кто не уверен, что их уровень физической подготовки позволит нести рюкзак на протяжении всей экспедиции. С портером ваше путешествие пройдет гораздо комфортнее и безопаснее.
          </p>
          <p class="tips__note-text">
            Эта услуга не включена в стоимость восхождения. Актуальную цену вы можете уточнить у менеджера. Она складывается из расчета оплаты труда и затрат на питание портера во время экспедиции. Altezza Travel состоит в
            <a href="https://altezza.travel/articles/about-kpap" target="_blank">организации по защите прав портеров KPAP</a> и платит участникам горной команды больше, чем другие операторы..
          </p>
        </div>
        <p class="tips__text" style="text-align: center">
          <b>О роли KPAP в восхождениях Altezza Travel мы рассказали в этом видео (на английском языке).</b>
        </p>
        <div class="tips__video">
          <iframe
            srcdoc="<style>
            * {
              padding: 0;
              margin: 0;
              overflow: hidden;
            }

            body, html {
              height: 100%;
            }

            a {
              display: flex;
              height: 100%;
            }

            img {
              position: absolute;
              width: 100%;
              height: 100%;
              inset: 0;
            }

            svg {
              margin: auto;
              filter: drop-shadow(1px 1px 10px hsl(206.5, 70.7%, 8%));
              transition: all 0.25s ease-in-out;
            }

            body:hover svg {
              filter: drop-shadow(1px 1px 10px hsl(206.5, 0%, 10%));
              transform: scale(1.2);
            }
          </style>
          <a href='https://www.youtube.com/embed/eonFDGI8LkM?si=5e80pnse3AyH8zmG&autoplay=1&mute=1'>
            <img src='https://img.youtube.com/vi/eonFDGI8LkM/maxresdefault.jpg' alt='Preview'>
            <svg xmlns='http://www.w3.org/2000/svg' width='80' height='59' fill='none'><path fill='#fff' d='M21.332 8h36v42.667h-36z'/><path fill='#E60000' d='M78.13 9.985c-1.6-4.923-6.895-7.905-11.767-8.589a249.56 249.56 0 0 0-52.725 0C8.765 2.08 3.456 5.033 1.87 9.985a99.938 99.938 0 0 0 0 38.493c1.6 4.916 6.894 7.905 11.767 8.589a249.568 249.568 0 0 0 52.724 0c4.873-.684 10.182-3.637 11.767-8.59a99.937 99.937 0 0 0 0-38.492Zm-47.7 34.573v-30.66l24.958 15.33c-8.414 5.17-16.58 10.181-24.958 15.33Z'/></svg>
          </a>
        "
            class="tips__iframe"
            loading="lazy"
            src="https://www.youtube.com/embed/_MRlLpSwAro?si=5e80pnse3AyH8zmG"
            frameborder="0"
            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
            referrerpolicy="strict-origin-when-cross-origin"
            allowfullscreen
          ></iframe>
        </div>
        <h3 class="tips__title">Что положить в баул</h3>
        <p class="tips__text">
          В него складывают теплые вещи для штурма вершины, спальный мешок и другую экипировку, которая не понадобится во время переходов между лагерями. Объем баула должен быть 100-140 литров, так как в сумки меньшего размера все снаряжение не поместится. Подходящие модели также можно арендовать у нас.
        </p>
        <p class="tips__text"><b>В баул нужно упаковать:</b></p>
        <ul class="tips__list">
          <li>Спальный мешок;</li>
          <li>Теплую куртку и штаны для штурма вершины;</li>
          <li>Теплые перчатки;</li>
          <li>Бафф;</li>
          <li>Дополнительные футболки и носки;</li>
          <li>Ботинки для штурма вершины;</li>
          <li>Два/три комплекта термобелья;</li>
          <li>Пауэрбанк;</li>
          <li>Личную аптечку;</li>
          <li>Зубную пасту и щетку;</li>
          <li>Грелки для рук.</li>
        </ul>
        <div class="tips__note">
          <div class="tips__note-title">Обратите внимание</div>
          <p class="tips__note-text">
            Спальный мешок должен быть выполнен из прочного водонепроницаемого материала и иметь уровень комфорта не ниже -12°C.
          </p>
        </div>
        <p class="tips__text"><b>Рекомендуемые предметы экипировки</b></p>
        <p class="tips__text">
          Некоторые предметы ощутимо повышают комфорт во время восхождения. Если есть возможность, рекомендуем взять с собой:
        </p>
        <ul class="tips__list">
          <li>Беруши;</li>
          <li>Увлажняющий крем для рук;</li>
          <li>Дополнительные флисовые кофты;</li>
          <li>Энергетические батончики;</li>
          <li>Термос.</li>
        </ul>
        <p class="tips__text">
          Правильно упаковать вещи помогают гермомешки-органайзеры. С их помощью вы можете разложить экипировку по категориям, например: “теплые вещи на штурм”, “флисовые кофты”, “гигиенические принадлежности” и так далее. Это поможет поддерживать порядок в сумке и быстрее находить все нужное.
        </p>
        <div class="tips__note">
          <div class="tips__note-title">Вес баула не должен превышать 15 кг</div>
          <p class="tips__note-text">
            Согласно правилам национального парка Килиманджаро, портеру разрешено переносить не более 20 кг, включая его личное снаряжение. Поэтому вес вашего баула не может превышать 15 кг. Если этого недостаточно, часть экипировки можно попробовать переложить в баулы ваших спутников или оплатить услуги дополнительного портера. В этом случае вы сможете взять с собой до 30 кг.
          </p>
        </div>
      </section>
      <section class="tips__section" id="section-4">
        <div class="tips__headline">
          <div class="tips__headline-picture">
            <img src="@/assets/img/tips/tips-clock.svg" alt="Clock">
          </div>
          <h2 class="tips__title">Время начала экспедиции</h2>
        </div>
        <p class="tips__text">
          Наш консультант сообщит время начала экспедиции во время брифинга, который мы проводим для всех участников перед восхождением. Пожалуйста, приходите на ресепшн отеля в назначенное время. Иногда в один день могут отправляться сразу несколько групп, и если прийти раньше или позднее, это может создать неудобства из-за скопления людей на ресепшене или сбить график отправления групп.
        </p>
        <p class="tips__text">
          Помимо рюкзака и баула, возьмите с собой вещи, которые вам не понадобятся на Килиманджаро. Менеджеры Altezza Travel примут их на ответственное хранение и наклеят на чемоданы стикеры с вашим именем.
        </p>
      </section>
      <section class="tips__section" id="section-5">
        <div class="tips__headline">
          <div class="tips__headline-picture">
            <img src="@/assets/img/tips/tips-luggage.svg" alt="Luggage">
          </div>
          <h2 class="tips__title">Хранение багажа и ценных вещей</h2>
        </div>
        <p class="tips__text">
          В нашем отеле Aishi Machame есть комната для хранения багажа, который вам не понадобится в экспедиции. Помещение находится под круглосуточным видеонаблюдением, а прилегающая территория отеля патрулируется вооруженной охраной.
        </p>
        <p class="tips__text">
          Для особо ценных предметов, таких как документы, наличные, гаджеты и драгоценности, предусмотрены дополнительные меры безопасности. Во время экспедиции они будут храниться в специальном сейфе с круглосуточным видеонаблюдением, датчиками движения и сигнализацией. Сейф застрахован на сумму 600 000 долларов США, однако нам еще ни разу не приходилось обращаться за возмещением. Уверяем, это одно из самых безопасных мест в Килиманджаро.
        </p>
        <p class="tips__text">
          Перед экспедицией передайте багаж и ценные вещи менеджерам Altezza Travel. Сразу же после отправки вашей экспедиции мы заберем их в комнату для хранения и сейф. Если у вас запланирована отправка из другого отеля, ваши вещи отвезут на машине Altezza Travel с соблюдением мер безопасности.
        </p>
        <p class="tips__text">
          Мы будем благодарны, если вы сложите ценные вещи в небольшую сумку размером до 40х40 см. Ячейки в сейфе ограничены по размеру, поэтому мы не сможем поместить туда дорожный чемодан. Если у вас нет подходящей сумки, вам предложат вместительный бумажный конверт. Что касается наличных, наш консультант пересчитает их с помощью банковской машинки, распечатает квитанцию с указанием номеров и номинала купюр, а после – упакует их в вакуумный пакет.
        </p>
        <p class="tips__text">
          За использование комнаты для хранения багажа и сейфа мы не берем платы. После экспедиции наш менеджер встретит вас и передаст ваши вещи из сейфа.
        </p>
        <div class="tips__note">
          <div class="tips__note-title">Наличные деньги и паспорта лучше не брать на Килиманджаро </div>
          <p class="tips__note-text">
            В экспедиции вам не понадобятся наличные и паспорта. Можно взять с собой небольшую сумму мелкими купюрами, так как по спуске вы можете оплатить услугу чистки обуви. Крупные суммы лучше оставить в нашем сейфе.
          </p>
          <p class="tips__note-text">
            Мы вынуждены делиться этой рекомендацией, поскольку на Килиманджаро иногда происходят кражи. Это не массовое явление, но администрация национального парка даже выпустила уведомление, запрещающее посетителям брать с собой более 200 долларов.
          </p>
          <p class="tips__note-text">
            В экспедициях Altezza Travel кражи никогда не случались, но в качестве дополнительной меры безопасности наша команда патрулирует лагерь ночью, чтобы к нему не приближались посторонние.
          </p>
          <p class="tips__note-text">
            Паспорта также лучше отдать нам на хранение. Их не нужно показывать на входе – все разрешения оформляются в электронном виде за несколько дней до начала экспедиции. К тому же сильные дожди или высокая влажность могут испортить документ.
          </p>
        </div>
      </section>
      <section class="tips__section" id="section-6">
        <div class="tips__headline">
          <div class="tips__headline-picture">
            <img src="@/assets/img/tips/tips-support.svg" alt="Support">
          </div>
          <h2 class="tips__title">Знакомство с гидами</h2>
        </div>
        <p class="tips__text">
          В день старта экспедиции менеджер познакомит вас с гидами. Каждый из них прошел обучение по программе Wilderness First Responder. Сдача этого экзамена подтверждает владение навыками оказания первой помощи и эвакуации в условиях дикой природы.
        </p>
        <p class="tips__text">
          Кроме того, гиды Altezza Travel хорошо разбираются в животном мире, растениях и истории парка Килиманджаро. Обо всем этом они будут рассказывать вам во время восхождения. После знакомства гиды упакуют баулы со снаряжением в автобус и команда отправится ко входу в национальный парк.
        </p>
        <div class="tips__video">
          <iframe
            srcdoc="<style>
            * {
              padding: 0;
              margin: 0;
              overflow: hidden;
            }

            body, html {
              height: 100%;
            }

            a {
              display: flex;
              height: 100%;
            }

            img {
              position: absolute;
              width: 100%;
              height: 100%;
              inset: 0;
            }

            svg {
              margin: auto;
              filter: drop-shadow(1px 1px 10px hsl(206.5, 70.7%, 8%));
              transition: all 0.25s ease-in-out;
            }

            body:hover svg {
              filter: drop-shadow(1px 1px 10px hsl(206.5, 0%, 10%));
              transform: scale(1.2);
            }
          </style>
          <a href='https://www.youtube.com/embed/aaQfHcIVjW8?si=fXm72KsJFdZ6aQ3J&autoplay=1&mute=1'>
            <img src='https://img.youtube.com/vi/aaQfHcIVjW8/maxresdefault.jpg' alt='Preview'>
            <svg xmlns='http://www.w3.org/2000/svg' width='80' height='59' fill='none'><path fill='#fff' d='M21.332 8h36v42.667h-36z'/><path fill='#E60000' d='M78.13 9.985c-1.6-4.923-6.895-7.905-11.767-8.589a249.56 249.56 0 0 0-52.725 0C8.765 2.08 3.456 5.033 1.87 9.985a99.938 99.938 0 0 0 0 38.493c1.6 4.916 6.894 7.905 11.767 8.589a249.568 249.568 0 0 0 52.724 0c4.873-.684 10.182-3.637 11.767-8.59a99.937 99.937 0 0 0 0-38.492Zm-47.7 34.573v-30.66l24.958 15.33c-8.414 5.17-16.58 10.181-24.958 15.33Z'/></svg>
          </a>
        "
            class="tips__iframe"
            loading="lazy"
            src="https://www.youtube.com/embed/aaQfHcIVjW8?si=fXm72KsJFdZ6aQ3J"
            frameborder="0"
            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
            referrerpolicy="strict-origin-when-cross-origin"
            allowfullscreen
          ></iframe>
        </div>
      </section>
      <section class="tips__section" id="section-7">
        <div class="tips__headline">
          <div class="tips__headline-picture">
            <img src="@/assets/img/tips/tips-gps.svg" alt="GPS">
          </div>
          <h2 class="tips__title">Ссылка на GPS трекер</h2>
        </div>
        <p class="tips__text">
          В день отправления экспедиции сотрудник Altezza Travel предоставит вам ссылку для отслеживания местоположения группы на Килиманджаро в реальном времени. Вы можете поделиться ею с близкими, чтобы они знали, где вы находитесь.
        </p>
        <div class="tips__note">
          <div class="tips__note-title">GPS не работает в лесу</div>
          <p class="tips__note-text">
            В первый день восхождения по маршрутам Мачаме и Умбве, а также при спуске по маршруту Мвека GPS не будет работать. Дело в том, что эти участки проходят в тропическом лесу, где верхушки деревьев блокируют сигнал. Не беспокойтесь: связь восстановится, как только группа выйдет на открытую местность.
          </p>
          <p class="tips__note-text">
            Также ваши близкие всегда могут связаться с нашими менеджерами и узнать, как проходит восхождение. Актуальные контакты указаны в конце этого руководства.
          </p>
        </div>
      </section>
      <section class="tips__section" id="section-8">
        <div class="tips__headline">
          <div class="tips__headline-picture">
            <img src="@/assets/img/tips/tips-water.svg" alt="Water">
          </div>
          <h2 class="tips__title">Вода на Килиманджаро</h2>
        </div>
        <h3 class="tips__title">Питьевой режим</h3>
        <p class="tips__text">Акклиматизация к высоте невозможна без достаточного потребления воды. <b>Во время экспедиции взрослому человеку рекомендуется выпивать 3–4 литра жидкости в день.</b> Это оптимальный объем для поддержания температуры тела, метаболизма и других процессов при повышенных физических нагрузках и пониженном содержании кислорода в воздухе. Чтобы избежать ощущения тяжести, наши эксперты советуют пить часто, но небольшими глотками. Гиды будут делать остановки примерно каждые полчаса.</p>
        <p class="tips__text">
          Многие путешественники используют питьевую систему CamelBak. Она позволяет пить на ходу и не доставать фляжку из рюкзака. В лагере удобнее пользоваться бутылкой.
        </p>
        <div class="tips__video">
          <iframe
            srcdoc="<style>
            * {
              padding: 0;
              margin: 0;
              overflow: hidden;
            }

            body, html {
              height: 100%;
            }

            a {
              display: flex;
              height: 100%;
            }

            img {
              position: absolute;
              width: 100%;
              height: 100%;
              inset: 0;
            }

            svg {
              margin: auto;
              filter: drop-shadow(1px 1px 10px hsl(206.5, 70.7%, 8%));
              transition: all 0.25s ease-in-out;
            }

            body:hover svg {
              filter: drop-shadow(1px 1px 10px hsl(206.5, 0%, 10%));
              transform: scale(1.2);
            }
          </style>
          <a href='https://www.youtube.com/embed/Se6y4n_FftU?si=NEo2tBmG3lcleDC-&autoplay=1&mute=1'>
            <img src='https://img.youtube.com/vi/Se6y4n_FftU/maxresdefault.jpg' alt='Preview'>
            <svg xmlns='http://www.w3.org/2000/svg' width='80' height='59' fill='none'><path fill='#fff' d='M21.332 8h36v42.667h-36z'/><path fill='#E60000' d='M78.13 9.985c-1.6-4.923-6.895-7.905-11.767-8.589a249.56 249.56 0 0 0-52.725 0C8.765 2.08 3.456 5.033 1.87 9.985a99.938 99.938 0 0 0 0 38.493c1.6 4.916 6.894 7.905 11.767 8.589a249.568 249.568 0 0 0 52.724 0c4.873-.684 10.182-3.637 11.767-8.59a99.937 99.937 0 0 0 0-38.492Zm-47.7 34.573v-30.66l24.958 15.33c-8.414 5.17-16.58 10.181-24.958 15.33Z'/></svg>
          </a>
        "
            class="tips__iframe"
            loading="lazy"
            src="https://www.youtube.com/embed/Se6y4n_FftU?si=NEo2tBmG3lcleDC-"
            frameborder="0"
            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
            referrerpolicy="strict-origin-when-cross-origin"
            allowfullscreen
          ></iframe>
        </div>
        <h3 class="tips__title">Где брать воду</h3>
        <p class="tips__text">
          Перед началом экспедиции восходителям предоставят бутилированную воду, которую можно перелить во фляжки и питьевые системы. Во время восхождения портеры будут набирать воду из горных источников и приносить в лагерь. Перед употреблением ее будут кипятить и очищать таблетками “Аквагард” для дополнительной защиты от микробов. Из-за этого она может приобрести легкий химический привкус. Если у вас острая восприимчивость к вкусам, можете попросить гидов ограничиться кипячением. Это безопасно: когда мы сами ходим на Килиманджаро, воду для сотрудников Altezza Travel только кипятят.
        </p>
        <p class="tips__text">
          При этом вкус воды можно улучшить, добавив в нее электролиты. Они придадут ей приятный фруктовый аромат и обогатят натрием, магнием, калием и другими полезными элементами. Электролиты можно привезти с собой или приобрести у нас. За дополнительной информацией обращайтесь к нашим менеджерам.
        </p><p class="tips__text">
        В общем, переживать о качестве воды на Килиманджаро не стоит. Наш опыт подтверждает, что пить ее безопасно: ежегодно Altezza Travel проводит более 800 экспедиций для 4500 путешественников. Среди них не было ни одного случая отравления.
        </p>
        <h3 class="tips__title">Объем фляжек и питьевых систем</h3>
        <p class="tips__text">
          Половину от дневной нормы – 2 литра – необходимо выпивать во время переходов. Поскольку источники воды находятся только вблизи лагерей, рекомендуем взять с собой две литровые фляжки или двухлитровую питьевую систему. Не переживайте, если в пути у вас закончится вода: наши гиды всегда берут небольшой дополнительный запас, чтобы в подобных ситуациях поделиться с участниками экспедиции.
        </p>
        <div class="tips__note">
          <div class="tips__note-title">Бутилированная вода</div>
          <p class="tips__note-text">
            Если вы не хотите пить воду из источников, можете заказать бутилированную. Однако в этом случае придется оплатить не только стоимость самой воды, но и услуги портеров, которые будут ее переносить. В эту сумму, помимо их зарплаты, будут включены расходы на питание, дополнительную палатку и т.д.
          </p>
          <p class="tips__note-text">
            Сообщите менеджеру, если вы хотите заказать бутилированную воду в свою экспедицию.
          </p>
        </div>
      </section>
      <section class="tips__section" id="section-9">
        <div class="tips__headline">
          <div class="tips__headline-picture">
            <img src="@/assets/img/tips/tips-medical.svg" alt="Medical">
          </div>
          <h2 class="tips__title">Медосмотры в экспедициях Altezza Travel</h2>
        </div>
        <p class="tips__text">
          Чтобы убедиться, что ваш организм успешно адаптируется к высоте, дважды в день гиды будут проводить медосмотры. Проходить их обязательно, даже если вы отлично себя чувствуете.
        </p>
        <p class="tips__text">
          После завтрака и ужина вас попросят ненадолго зайти в медицинскую палатку, где гиды проверят уровень кислорода в крови и зададут вопросы о вашем самочувствии. Общайтесь с гидом как с врачом: если испытываете недомогание – не скрывайте. Акклиматизацию нередко сопровождают головная боль, слабость, рвота, диарея или трудности с дыханием. Сообщайте обо всех, даже самых незначительных симптомах.
        </p>
        <p class="tips__text">
          В этом случае гиды предложат вам лекарство (подробнее о наших аптечках – ниже), дадут подышать концентрированным кислородом из баллона или замедлят темп восхождения на следующем переходе. Таким образом они скорректируют ход акклиматизации, и вы сможете с комфортом продолжить восхождение.
        </p>
        <p class="tips__text">
          Обязательно укажите в медицинской форме, если вы принимаете какие-либо препараты по рецепту врача. Мы передадим эту информацию гидам, чтобы они не предлагали вам лекарства, у которых есть соответствующие противопоказания.
        </p>
        <div class="tips__note">
          <div class="tips__note-title">Конфиденциальность медицинской информации </div>
          <p class="tips__note-text">
            Информация, которую вы сообщите нашим гидам или укажете в медицинской форме, может быть раскрыта только врачу в случае эвакуации. К ней нет доступа у других участников экспедиции или у сотрудников Altezza Travel, кроме гидов и менеджеров. Медосмотры проводятся в индивидуальной палатке наедине с гидами, а записи из медицинского журнала экспедиции удаляются через 24 месяца после восхождения.
          </p>
        </div>
        <div class="tips__video">
          <iframe
            srcdoc="<style>
            * {
              padding: 0;
              margin: 0;
              overflow: hidden;
            }

            body, html {
              height: 100%;
            }

            a {
              display: flex;
              height: 100%;
            }

            img {
              position: absolute;
              width: 100%;
              height: 100%;
              inset: 0;
            }

            svg {
              margin: auto;
              filter: drop-shadow(1px 1px 10px hsl(206.5, 70.7%, 8%));
              transition: all 0.25s ease-in-out;
            }

            body:hover svg {
              filter: drop-shadow(1px 1px 10px hsl(206.5, 0%, 10%));
              transform: scale(1.2);
            }
          </style>
          <a href='https://www.youtube.com/embed/ygegdam7-Kk?si=ij7IOPoiQPXza03M&autoplay=1&mute=1'>
            <img src='https://img.youtube.com/vi/ygegdam7-Kk/maxresdefault.jpg' alt='Preview'>
            <svg xmlns='http://www.w3.org/2000/svg' width='80' height='59' fill='none'><path fill='#fff' d='M21.332 8h36v42.667h-36z'/><path fill='#E60000' d='M78.13 9.985c-1.6-4.923-6.895-7.905-11.767-8.589a249.56 249.56 0 0 0-52.725 0C8.765 2.08 3.456 5.033 1.87 9.985a99.938 99.938 0 0 0 0 38.493c1.6 4.916 6.894 7.905 11.767 8.589a249.568 249.568 0 0 0 52.724 0c4.873-.684 10.182-3.637 11.767-8.59a99.937 99.937 0 0 0 0-38.492Zm-47.7 34.573v-30.66l24.958 15.33c-8.414 5.17-16.58 10.181-24.958 15.33Z'/></svg>
          </a>
        "
            class="tips__iframe"
            loading="lazy"
            src="https://www.youtube.com/embed/ygegdam7-Kk?si=ij7IOPoiQPXza03M"
            frameborder="0"
            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
            referrerpolicy="strict-origin-when-cross-origin"
            allowfullscreen
          ></iframe>
        </div>
        <h3 class="tips__title">Что находится в аптечках Altezza Travel</h3>
        <p class="tips__text">
          В экспедициях Altezza используется два типа медицинских аптечек. Первая – большая кемпинговая – находится в медицинской палатке в лагере. В ней хранятся медикаменты от распространенных недугов, которые могут возникнуть во время путешествия: обезболивающие, антигистаминные, противовирусные средства, лекарства от отравлений и т.д.
        </p>
        <p class="tips__text">
          Вторая – тактическая – при себе у каждого гида. Она содержит все необходимое для оказания помощи во время переходов: бинты, пластыри, турникеты и обезболивающие на случай травм. Подробнее можно прочитать в нашей <a href="https://altezza.travel/articles/first-aid-kits-altezza-travel" target="_blank">статье об аптечках</a>.
        </p>
        <h3 class="tips__title">Диакарб (Диамокс)</h3>
        <p class="tips__text">
          Мы используем препарат “Диакарб” для уменьшения неприятных симптомов акклиматизации – головной боли и слабости. Он немного повышает кислотность крови, что приводит к учащению дыхания. Благодаря этому организм быстрее насыщается кислородом и процесс акклиматизации ускоряется.
        </p>
        <p class="tips__text">
          Согласно нашей внутренней статистике, практически все участники экспедиции, которые используют “Диакарб”, успешно достигают вершины. Офисные сотрудники Altezza Travel обязательно принимают его во время восхождений.
        </p>
        <p class="tips__text">
          Рекомендуемая дневная доза – 250 мг в день. Она делится на два приема – утром и после обеда. Перед сном препарат лучше не принимать, поскольку он учащает мочеиспускание.
        </p>
        <p class="tips__text">
          У “Диакарба” есть необычный побочный эффект – легкое покалывание на кончиках пальцев и на лице. Не переживайте, оно проходит на третий-четвертый день. Привозить препарат с собой не нужно, он входит в состав наших аптечек. Принимать его можно превентивно, для этого подойдите к нашему менеджеру перед началом экспедиции.
        </p>
        <div class="tips__note">
          <div class="tips__note-title">Проконсультируйтесь с врачом</div>
          <p class="tips__note-text">
            Перед приемом “Диакарба” стоит обязательно проконсультироваться с врачом. Отдельным категориям путешественников, например, беременным и людям, имеющим аллергию на сульфаты, он противопоказан.
          </p>
        </div>
        <div class="tips__video">
          <iframe
            srcdoc="<style>
            * {
              padding: 0;
              margin: 0;
              overflow: hidden;
            }

            body, html {
              height: 100%;
            }

            a {
              display: flex;
              height: 100%;
            }

            img {
              position: absolute;
              width: 100%;
              height: 100%;
              inset: 0;
            }

            svg {
              margin: auto;
              filter: drop-shadow(1px 1px 10px hsl(206.5, 70.7%, 8%));
              transition: all 0.25s ease-in-out;
            }

            body:hover svg {
              filter: drop-shadow(1px 1px 10px hsl(206.5, 0%, 10%));
              transform: scale(1.2);
            }
          </style>
          <a href='https://www.youtube.com/embed/ZcuA_GapbTQ?si=lc1V-cdJrKBesG3i&autoplay=1&mute=1'>
            <img src='https://img.youtube.com/vi/ZcuA_GapbTQ/maxresdefault.jpg' alt='Preview'>
            <svg xmlns='http://www.w3.org/2000/svg' width='80' height='59' fill='none'><path fill='#fff' d='M21.332 8h36v42.667h-36z'/><path fill='#E60000' d='M78.13 9.985c-1.6-4.923-6.895-7.905-11.767-8.589a249.56 249.56 0 0 0-52.725 0C8.765 2.08 3.456 5.033 1.87 9.985a99.938 99.938 0 0 0 0 38.493c1.6 4.916 6.894 7.905 11.767 8.589a249.568 249.568 0 0 0 52.724 0c4.873-.684 10.182-3.637 11.767-8.59a99.937 99.937 0 0 0 0-38.492Zm-47.7 34.573v-30.66l24.958 15.33c-8.414 5.17-16.58 10.181-24.958 15.33Z'/></svg>
          </a>
        "
            class="tips__iframe"
            loading="lazy"
            src="https://www.youtube.com/embed/ZcuA_GapbTQ?si=lc1V-cdJrKBesG3i"
            frameborder="0"
            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
            referrerpolicy="strict-origin-when-cross-origin"
            allowfullscreen
          ></iframe>
        </div>
        <h3 class="tips__title">На период восхождения стоит воздержаться от алкоголя</h3>
        <p class="tips__text">
          Брать с собой спиртные напитки не следует по нескольким причинам:
        </p>
        <p class="tips__text"><b>Это запрещено правилами парка Килиманджаро.</b> Хотя рейнджеры, разумеется, не будут досматривать ваш рюкзак, правила лучше не нарушать. Если в лагерях заметят алкоголь, нашу компанию могут оштрафовать.</p>
        <p class="tips__text"><b>Алкоголь осложняет акклиматизацию.</b> Спиртные напитки замедляют адаптационные процессы. Есть риск оказаться на высоте раньше, чем к этому будет готов организм. Это может привести к горной болезни.</p>
        <p class="tips__text"><b>Алкоголь нейтрализует действие медикаментов.</b> Если для лучшей акклиматизации вы решили принимать “Диакарб”, то алкоголь в значительной степени снизит его эффективность. Это касается и других препаратов: в случае отравления, головной боли или тошноты лекарства из нашей аптечки не помогут.</p>
        <div class="tips__video">
          <iframe
            srcdoc="<style>
            * {
              padding: 0;
              margin: 0;
              overflow: hidden;
            }

            body, html {
              height: 100%;
            }

            a {
              display: flex;
              height: 100%;
            }

            img {
              position: absolute;
              width: 100%;
              height: 100%;
              inset: 0;
            }

            svg {
              margin: auto;
              filter: drop-shadow(1px 1px 10px hsl(206.5, 70.7%, 8%));
              transition: all 0.25s ease-in-out;
            }

            body:hover svg {
              filter: drop-shadow(1px 1px 10px hsl(206.5, 0%, 10%));
              transform: scale(1.2);
            }
          </style>
          <a href='https://www.youtube.com/embed/cBQcW7O1z6A?si=o_LoZcBlClyG-6cC&autoplay=1&mute=1'>
            <img src='https://img.youtube.com/vi/cBQcW7O1z6A/maxresdefault.jpg' alt='Preview'>
            <svg xmlns='http://www.w3.org/2000/svg' width='80' height='59' fill='none'><path fill='#fff' d='M21.332 8h36v42.667h-36z'/><path fill='#E60000' d='M78.13 9.985c-1.6-4.923-6.895-7.905-11.767-8.589a249.56 249.56 0 0 0-52.725 0C8.765 2.08 3.456 5.033 1.87 9.985a99.938 99.938 0 0 0 0 38.493c1.6 4.916 6.894 7.905 11.767 8.589a249.568 249.568 0 0 0 52.724 0c4.873-.684 10.182-3.637 11.767-8.59a99.937 99.937 0 0 0 0-38.492Zm-47.7 34.573v-30.66l24.958 15.33c-8.414 5.17-16.58 10.181-24.958 15.33Z'/></svg>
          </a>
        "
            class="tips__iframe"
            loading="lazy"
            src="https://www.youtube.com/embed/cBQcW7O1z6A?si=o_LoZcBlClyG-6cC"
            frameborder="0"
            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
            referrerpolicy="strict-origin-when-cross-origin"
            allowfullscreen
          ></iframe>
        </div>
      </section>
      <section class="tips__section" id="section-10">
        <div class="tips__headline">
          <div class="tips__headline-picture">
            <img src="@/assets/img/tips/tips-devices.svg" alt="Devices">
          </div>
          <h2 class="tips__title">Телефоны, планшеты и другие гаджеты</h2>
        </div>
        <p class="tips__text">Используя электронные устройства на Килиманджаро, важно помнить о двух вещах:</p>
        <p class="tips__text">
          <b>На Килиманджаро нет постоянных источников электричества.</b> Возьмите с собой пауэрбанки или портативные солнечные батареи. Их можно прицепить к рюкзакам, и в солнечную погоду они будут заряжаться во время переходов.
        </p>
        <p class="tips__text">
          <b>Поставьте телефон в режим авиаперелета.</b>
          Отключайте его только когда хотите отправить сообщение или позвонить. Такая возможность появится со второго-третьего дня. В нижних лагерях Килиманджаро не работает роуминг.
        </p>
        <p class="tips__text">
          <b>При низких температурах батарея разряжается быстрее.</b> Это актуально в ночное время и на штурме вершины, когда температура опускается ниже нуля. Чтобы сохранить заряд, держите телефон в тепле – в спальном мешке или во внутреннем кармане куртки.
        </p>
      </section>
      <section class="tips__section" id="section-11">
        <div class="tips__headline">
          <div class="tips__headline-picture">
            <img src="@/assets/img/tips/tips-shower.svg" alt="Shower">
          </div>
          <h2 class="tips__title">Туалеты и души на Килиманджаро</h2>
        </div>
        <p class="tips__text">
          На Килиманджаро есть два типа туалетов:
        </p>
        <h3 class="tips__title">Стационарные общественные</h3>
        <p class="tips__text">
          В каждом лагере и в некоторых местах на переходах есть общественные туалеты, за чистоту которых отвечает администрация парка. Иногда их используют сотни восходителей за день, и у персонала не хватает времени поддерживать их в надлежащем состоянии. Тем, кто ожидает от путешествия большего комфорта, мы предлагаем рассмотреть платный альтернативный вариант.
        </p>
        <h3 class="tips__title">Портативные кемпинговые туалеты</h3>
        <p class="tips__text">
          Это комфортный биотуалет, который за отдельную плату устанавливается недалеко от вашей палатки. Стоимость этой услуги включает в себя также работу портера, который будет переносить его из лагеря в лагерь и поддерживать чистоту. Одним туалетом могут пользоваться до трех человек. В этом случае цена делится на всех. Если это предпочтительный вариант, но вы путешествуете в одиночку, сообщите об этом менеджеру. Он постарается найти желающих. Портативные туалеты доступны на всех маршрутах, кроме Марангу.
        </p>
        <h3 class="tips__title">Что делать на переходах</h3>
        <p class="tips__text">
          Справлять нужду на переходах можно чуть отойдя от туристического маршрута. Высокие кусты или валуны обеспечат необходимую приватность. Важно: все гигиенические принадлежности необходимо забрать с собой. Их можно будет выкинуть в специальный мешок в лагере.
        </p>
        <h3 class="tips__title">Кемпинговые души</h3>
        <p class="tips__text">
          Стационарных душевых в лагерях нет, большинство восходителей пользуются гигиеническими влажными салфетками. Единственная возможность принять душ – взять с собой переносной.
        </p>
        <p class="tips__text">
          Как и в случае с кемпинговым туалетом, это платная услуга, в стоимость которой включены услуги портера и сопутствующие расходы. Он будет переносить конструкцию из лагеря в лагерь, следить за чистотой, а также приносить и греть воду. Портативные души не отличаются сильным напором воды, но этого вполне достаточно, чтобы освежиться и помыть голову. Забронировать эту услугу можно в личном кабинете на портале Altezza Travel.
        </p>
        <h3 class="tips__title">Утренняя и вечерняя гигиена</h3>
        <p class="tips__text">
          Каждое утро и вечер наша команда будет заправлять кемпинговые умывальники теплой водой, чтобы участники экспедиции могли умыться и почистить зубы. Это включено в стоимость экспедиции.
        </p>
      </section>
      <section class="tips__section" id="section-12">
        <div class="tips__headline">
          <div class="tips__headline-picture">
            <img src="@/assets/img/tips/tips-leaf.svg" alt="Leaf">
          </div>
          <h2 class="tips__title">Как не навредить экосистеме Килиманджаро</h2>
        </div>
        <p class="tips__text">
          Ежегодно Килиманджаро посещает около 50 000 путешественников. За последние десять лет на его склонах побывало больше людей, чем за предыдущее столетие, что создает большие риски для экосистемы вулкана. Чтобы сохранить ее для будущих поколений, соблюдайте несколько простых правил:
        </p>
        <p class="tips__text">
          <b>Не оставляйте мусор на маршрутах.</b> Возьмите у наших менеджеров специальные пакеты-зиплоки и собирайте в них использованные салфетки, бумагу и прочее. Выбросить их можно будет в урну в лагере. Использованные батарейки отдайте гиду: в северной Танзании есть всего один центр для их безопасной утилизации.
        </p>
        <p class="tips__text">
          Altezza Travel не только следит за чистотой в наших экспедициях, но и дважды в год – в апреле и мае – отправляет на Килиманджаро специальные команды, чтобы собрать мусор, оставленный другими путешественниками. Подробнее об этом мы рассказывали в нашем
          <a href="https://altezza.travel/articles/no-litter-on-kilimanjaro" target="_blank">репортаже</a>.
        </p>
        <p class="tips__text">
          <b>Не выбрасывайте сигаретные окурки.</b>
          Небрежно потушенная сигарета может стать причиной сильного пожара, как это случилось в 2020 и 2022 годах. Тогда на Килиманджаро выгорело много гектаров леса. В тушении приняли участие горные команды Altezza Travel, самые крупные среди туроператоров, откликнувшихся на призыв парка. Об этом мы также рассказывали в нашем <a href="https://altezza.travel/articles/fire-on-kilimanjaro" target="_blank">репортаже</a>.
        </p>
        <p class="tips__text">
          <b>Не берите на память цветы, камни, обсидиан и другие предметы.</b> Во время восхождения может возникнуть желание взять что-то на память из парка. Мы призываем этого не делать: Килиманджаро посещают десятки тысяч людей, и если каждый возьмет по камешку, экосистема парка может серьезно пострадать.
        </p>
        <p class="tips__text">
          Более того, вывозить такие артефакты запрещено законом. Если камень, обсидиан, высушенный цветок или другие предметы природного происхождения обнаружит пограничная служба в аэропорту, могут возникнуть проблемы.
        </p>
        <p class="tips__text">
          <b>Не берите с собой одноразовые пластиковые бутылки.</b> Их запрещено использовать на территории парка. Хотя рейнджеры обычно ограничиваются замечаниями, лучше возьмите флягу. Если у вас ее нет, можете купить у Altezza Travel.
        </p>
        <p class="tips__text">
          <b>Не кормите диких животных.</b> На Килиманджаро вы можете встретить обезьян, грызунов, птиц и других животных. Не давайте им еду. Это приучает их к человеку, они меняют свои привычки и со временем теряют навыки выживания в дикой природе.
        </p>
      </section>
      <section class="tips__section" id="section-13">
        <div class="tips__headline">
          <div class="tips__headline-picture">
            <img src="@/assets/img/tips/tips-beginning.svg" alt="Info">
          </div>
          <h2 class="tips__title">Начало восхождения</h2>
        </div>
        <p class="tips__text">
          Из отеля участников восхождения доставят на автобусе до стартовой точки. В зависимости от маршрута дорога займет от 30 минут до трех часов. По дороге вы сможете насладиться видами аутентичных африканских деревень, понаблюдать за их жителями и, если повезет, встретить диких животных вблизи Национального парка Килиманджаро.
        </p>
        <p class="tips__text">
          У входа в парк будет небольшая остановка: пока гиды оформляют необходимые для экспедиции документы, вы сможете немного отдохнуть перед переходом в первый лагерь.
        </p>
      </section>
      <section class="tips__section" id="section-14">
        <div class="tips__headline">
          <div class="tips__headline-picture">
            <img src="@/assets/img/tips/tips-mountain.svg" alt="Ascent">
          </div>
          <h2 class="tips__title">Как проходит обычный день на Килиманджаро</h2>
        </div>
        <p class="tips__text">
          Обычный день в экспедиции начинается с кофе, который в 06:30 портер приносит вам прямо в палатку. После утренней гигиены участники восхождения собираются за общим столом на завтрак, который готовит и подает команда сопровождения.
        </p>
        <p class="tips__text">
          Затем гиды проводят утренний медосмотр: задают вопросы об общем самочувствии, измеряют уровень кислорода в крови и заполнят медкарту. Принимающим “Диакарб” выдают дневную порцию.
        </p>
        <p class="tips__text">
          После медосмотра группа отправляется в следующий лагерь. О продолжительности и особенностях маршрута вам расскажут во время брифинга накануне. В среднем переходы занимают от четырех до семи часов. Для большинства путешественников они неутомительны: каждые 30-40 минут гиды организуют короткие привалы, чтобы вы могли отдохнуть, попить воды и сделать фотографии.
        </p>
        <p class="tips__text">
          Иногда физическая подготовка некоторых участников позволяет проходить ежедневный маршрут быстрее запланированного. Однако делать этого не стоит: размеренный темп необходим для успешной акклиматизации. У каждого участника он свой, поэтому группа иногда делится на подгруппы, чтобы переходы проходили комфортно для всех.
        </p>
        <div class="tips__video">
          <iframe
            srcdoc="<style>
            * {
              padding: 0;
              margin: 0;
              overflow: hidden;
            }

            body, html {
              height: 100%;
            }

            a {
              display: flex;
              height: 100%;
            }

            img {
              position: absolute;
              width: 100%;
              height: 100%;
              inset: 0;
            }

            svg {
              margin: auto;
              filter: drop-shadow(1px 1px 10px hsl(206.5, 70.7%, 8%));
              transition: all 0.25s ease-in-out;
            }

            body:hover svg {
              filter: drop-shadow(1px 1px 10px hsl(206.5, 0%, 10%));
              transform: scale(1.2);
            }
          </style>
          <a href='https://www.youtube.com/embed/7n6uWEEpam8?si=FwZk1g6f7tpedK4L&autoplay=1&mute=1'>
            <img src='https://img.youtube.com/vi/7n6uWEEpam8/maxresdefault.jpg' alt='Preview'>
            <svg xmlns='http://www.w3.org/2000/svg' width='80' height='59' fill='none'><path fill='#fff' d='M21.332 8h36v42.667h-36z'/><path fill='#E60000' d='M78.13 9.985c-1.6-4.923-6.895-7.905-11.767-8.589a249.56 249.56 0 0 0-52.725 0C8.765 2.08 3.456 5.033 1.87 9.985a99.938 99.938 0 0 0 0 38.493c1.6 4.916 6.894 7.905 11.767 8.589a249.568 249.568 0 0 0 52.724 0c4.873-.684 10.182-3.637 11.767-8.59a99.937 99.937 0 0 0 0-38.492Zm-47.7 34.573v-30.66l24.958 15.33c-8.414 5.17-16.58 10.181-24.958 15.33Z'/></svg>
          </a>
        "
            class="tips__iframe"
            loading="lazy"
            src="https://www.youtube.com/embed/7n6uWEEpam8?si=FwZk1g6f7tpedK4L"
            frameborder="0"
            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
            referrerpolicy="strict-origin-when-cross-origin"
            allowfullscreen
          ></iframe>
        </div>
        <p class="tips__text">
          В следующий лагерь вы придете в районе полудня. К тому времени команда портеров уже установит палатки и приготовит обед. После отдыха гиды пригласят вас на акклиматизационный выход – прогулку с набором высоты на 100-200 метров, которая обычно занимает не больше полутора часов.
        </p>
        <p class="tips__text">
          Акклиматизационные выходы не обязательны, но мы рекомендуем участвовать в них. Наш опыт показывает, что такие прогулки значительно повышают шансы успешно достигнуть вершины.
        </p>
      </section>
      <section class="tips__section" id="section-15">
        <div class="tips__headline">
          <div class="tips__headline-picture">
            <img src="@/assets/img/tips/tips-food.svg" alt="Food">
          </div>
          <h2 class="tips__title">Как кормят в экспедициях Altezza Travel</h2>
        </div>
        <p class="tips__text">
          Горное меню составлено с учетом того, что во время восхождения путешественникам нужно больше энергии, чем в обычной жизни. В разработке рациона участвовали профессиональные диетологи. Они помогли сделать так, чтобы еда была вкусной и разнообразной. Вот несколько примеров того, что мы подаем в экспедициях:
        </p>
        <h3 class="tips__title">Завтраки</h3>
        <p class="tips__text">
          На завтрак мы предлагаем овсяную кашу, яичницу или омлет, сосиски, жареные помидоры, бобы и авокадо. На десерт всегда есть свежие фрукты, бисквиты, чай или кофе.
        </p>
        <h3 class="tips__title">Обеды и ужины</h3>
        <p class="tips__text">
          На обед и ужин мы подаем овощные супы, говядину, курицу или спагетти с соусом болоньезе. В качестве гарниров команда готовит картофель или рис. На столе также всегда есть салаты, цукини, тушеные овощи и авокадо. На десерт подают свежие фрукты: маракуйю, манго, апельсины и бананы.
        </p>
        <p class="tips__text">
          У нас также есть специальные варианты меню для вегетарианцев, веганов и тех, кто придерживается безглютеновой диеты. Если у вас есть ограничения по питанию, сообщите об этом менеджеру, и мы обязательно постараемся это учесть.
        </p>
        <div class="tips__note">
          <div class="tips__note-title">Приготовление еды</div>
          <p class="tips__note-text">
            На Килиманджаро запрещено разводить костры, здесь нет стационарных источников огня или привычных кухонь. Для приготовления еды команда использует переносные горелки, которые устанавливаются в специальной палатке. В непогоду готовить на них бывает сложно, но команда всегда делает все возможное, чтобы еда соответствовала нашим стандартам.
          </p>
        </div>
      </section>
      <section class="tips__section" id="section-16">
        <div class="tips__headline">
          <div class="tips__headline-picture">
            <img src="@/assets/img/tips/tips-rest.svg" alt="Rest">
          </div>
          <h2 class="tips__title">О чем важно помнить в лагере</h2>
        </div>
        <p class="tips__text">
          <b>Не закрывайте вентиляционные отверстия в палатке.</b> Они обеспечивают поступление кислорода, что особенно важно для качественного сна. Кроме того, если их закрыть, внутри начнет скапливаться влага, которая со временем начнет капать с потолка прямо на вас.
        </p>
        <p class="tips__text">
          <b>В парке Килиманджаро запрещено разводить огонь.</b> Это меры безопасности: палатка полностью сгорает менее чем за минуту. Если вам нужно покурить, сделайте это на расстоянии.
        </p>
        <p class="tips__text">
          <b>Аккуратно проходите возле палаток в темное время суток.</b> После захода солнца можно споткнуться об оттяжки палаток и упасть. Всегда используйте фонарик, когда возвращаетесь с ужина или выходите ночью в туалет.
        </p>
        <p class="tips__text">
          <b>В каждом лагере есть общественные туалеты.</b> Они доступны для команды сопровождения и путешественников. Если вы предпочитаете более комфортные условия, за дополнительную плату можно взять кемпинговый биотуалет. Главное – не справлять нужду в окрестностях лагеря.
        </p>
        <p class="tips__text">
          <b>В лагерях иногда бывает скользко.</b> Если вы хотите взять с собой отдельную обувь для лагеря, обратите внимание на подошву. Обычные сланцы могут не подойти, лучше сделать выбор в пользу кроксов.
        </p>
      </section>
      <section class="tips__section" id="section-17">
        <div class="tips__headline">
          <div class="tips__headline-picture">
            <img src="@/assets/img/tips/tips-socks.svg" alt="Socks">
          </div>
          <h2 class="tips__title">Как не замерзнуть на Килиманджаро</h2>
        </div>
        <p class="tips__text">
          На Килиманджаро часто меняется погода. Вот несколько советов, которые помогут чувствовать себя комфортно во время восхождения:
        </p>
        <p class="tips__text">
          <b>Одевайтесь “слоями”.</b> В солнечные дни надевайте треккинговые штаны, синтетическую футболку и флисовую кофту при необходимости. В дождливую погоду – штаны и куртку с мембраной, в холодную – термобелье. Его также советуем надевать на переходах в верхние лагеря.
        </p>
        <p class="tips__text" style="margin-right: -15px;">
          Подробнее об этом наши эксперты рассказывали в материале о <a href="https://altezzatravel.ru/climbing-kilimanjaro/packing-list?_gl=1*78x53n*_gcl_aw*R0NMLjE3MzAxNDIxNTMuQ2owS0NRanc3UHk0QmhDYkFSSXNBTU14LV9JTzRMUTJYNjNkNmJWNGh4MW94RmR5SHBkT3lSc2dXY19GZS1wak53Z2oxWlp0a1BvcU5pWWFBci1yRUFMd193Y0I.*_gcl_au*MTY4MzIyNTI1Mi4xNzI3NDYwMTM2" target="_blank">снаряжении на Килиманджаро</a>.
        </p>
        <p class="tips__text">
          <b>Обязательно переодевайтесь в лагерях.</b> По прибытии в лагерь активность снижается. Влага, скопившаяся на одежде во время перехода, начнет остывать, а вы – мерзнуть. Для треккинга лучше выбирать одежду из специальных синтетических материалов, которые впитывают пот и выводят его на поверхность. А вот для отдыха в лагере лучше подойдут хлопок и шерсть, которые сохраняют тепло.
        </p>
        <p class="tips__text">
          <b>Используйте солнечные дни для сушки термобелья и другой экипировки.</b> Погода на Килиманджаро часто непредсказуема, поэтому при благоприятных условиях важно воспользоваться возможностью. В пасмурные или дождливые дни высушить промокшее снаряжение может быть значительно сложнее или невозможно вовсе.
        </p>
        <p class="tips__text">
          <b>Возьмите с собой термос.</b> У каждого гида на восхождении всегда есть термос с чаем и снэки, которыми путешественников угощают на привалах. Но если есть возможность, возьмите с собой свой термос. В горах горячий чай с сахаром помогает быстро восстановить силы, и чем больше его у группы – тем лучше.
        </p>
        <p class="tips__text">
          Термос также пригодится ночью, когда температура опускается до -5°C, а в высотных лагерях – до -10°C. Вода во фляжке быстро остывает, а иногда даже замерзает. Разбавляя ее горячей водой из термоса, вы сможете пить без риска простудить горло.
        </p>
        <p class="tips__text">
          <b>Возьмите с собой химические грелки для рук и пальцев ног.</b> Они пригодятся во время самого холодного отрезка пути – на штурме вершины. Будет достаточно двух-трех пар. Они не продаются в Танзании, поэтому важно купить их до поездки и взять с собой.
        </p>
        <h3 class="tips__title">Как правильно пользоваться химическими грелками</h3>
        <p class="tips__text">
          Внимательно прочитайте инструкцию на упаковке. Большинство грелок работают так: открываете пакет и резкими движениями встряхните содержимое 3-4 минуты. Затем вставляете между флисовой и теплой перчаткой, а химические грелки для ног – между носками и ботинком.
        </p>
        <p class="tips__text">
          Можно использовать один пакет, чтобы потренироваться дома или в отеле перед началом экспедиции.
        </p>
        <h3 class="tips__title">Как согреться ночью</h3>
        <p class="tips__text">
          <b>Убедитесь, что у вас достаточно теплый спальный мешок.</b> Для восхождения на Килиманджаро вам понадобится спальный мешок с уровнем комфорта не ниже -12°C. В более легких мешках ночами будет холодно. Рекомендуем взять лайнер – он повысит температуру на 5-7 градусов в особо морозные ночи.
        </p>
        <p class="tips__text">
          <b>На ночь надевайте термобелье.</b> Для экспедиции рекомендуем взять два/три комплекта: для дневных переходов и один, самый теплый, для сна и штурма вершины.
        </p>
        <p class="tips__text">
          <b>Каждый вечер портеры будут приносить грелку.</b> Положите ее в спальный мешок, и в течение нескольких минут станет значительно теплее.
        </p>
        <p class="tips__text">
          <b>Перелейте воду в термос.</b> Если вы пьете воду ночью или сразу после пробуждения, лучше перелить ее из фляги в термос. Там она не остынет, а в особо холодные ночи – не превратится в лед.
        </p>
        <h3 class="tips__title">Как держать вещи сухими</h3>
        <p class="tips__text">
          На Килиманджаро могут внезапно начаться дожди. Чтобы не промокло снаряжение, соблюдайте несколько правил:
        </p>
        <p class="tips__text">
          <b>Положите в рюкзак мембранную куртку и штаны.</b> Если начнется дождь, вы сможете быстро надеть их поверх одежды и продолжить восхождение с комфортом.
        </p>
        <p class="tips__text">
          <b>Используйте пластиковые мешки или драйбеги.</b> Укладывая вещи в баул, стоит сначала упаковать их в водонепроницаемые пластиковые мешки или специальные драйбеги, которые защитят их в случае сильных дождей.
        </p>
        <p class="tips__text">
          <b>Выбирайте качественные баулы.</b> Баул – основа того, что ваши теплые вещи для штурма вершины не промокнут на переходах между лагерями. Они удобнее и надежнее больших рюкзаков. Если у вас нет и не хотите покупать, можете арендовать у нас по прилете. Мы разработали эти баулы с учетом погодных условий на Килиманджаро.
        </p>
        <p class="tips__text">
          <b>В сезон дождей возьмите запасную пару обуви.</b> Если вы совершаете восхождение в апреле–июне или ноябре–декабре, стоит взять с собой еще одну пару ботинок. Если основная промокнет, высушить ее будет сложно, а иногда – невозможно.
        </p>
        <p class="tips__text">
          <b>Возьмите запасные носки и перчатки.</b> Как и обувь, их тяжело сушить в сезон дождей. Запасные пары помогут с комфортом продолжить восхождение.
        </p>
      </section>
      <section class="tips__section" id="section-18">
        <div class="tips__headline">
          <div class="tips__headline-picture">
            <img src="@/assets/img/tips/tips-night.svg" alt="Socks">
          </div>
          <h2 class="tips__title">Ночь штурма вершины</h2>
        </div>
        <p class="tips__text">
          Вы придете в штурмовой лагерь к обеду. Сразу после него мы рекомендуем лечь спать: вам нужно максимально восстановиться перед ночным штурмом вершины и последующим утренним спуском.
        </p>
        <p class="tips__text">
          Гиды разбудят вас около 23:00, и после позднего ужина проведут финальный медосмотр. Большинство начинают штрум в районе полуночи, но если в предыдущие дни ваша группа двигалась с хорошей скоростью, гиды могут запланировать выход на более позднее время. В этом случае будет возможность подольше поспать и выйти на штурм в районе 02:00.
        </p>
        <div class="tips__note">
          <div class="tips__note-title">Почему на штурм Килиманджаро выходят ночью</div>
          <p class="tips__note-text">
            На вершину Килиманджаро нужно выйти к рассвету. В это время с нее открывается живописный пейзаж из-за отсутствия или небольшого количества облаков.
          </p>
          <p class="tips__note-text">
            Кроме того, достигнув вершины утром, вы сможете спуститься в лагерь Хоромбо или Миллениум к обеду. Если выйти позднее, есть риск, что спуск затянется до захода солнца. Учитывая усталость участников после сложного штурма, это чревато опасностями: в темное время становится холоднее, ухудшается внимательность и концентрация.
          </p>
          <p class="tips__note-text">
            Еще одна причина – с заходом солнца на Килиманджаро запрещены полеты спасательного вертолета. Это правило действует в горах по всему миру.
          </p>
        </div>
        <p class="tips__text">
          Большинство групп выходят на вершину в промежутке между 06:30 и 09:00 и проводят там около 20-30 минут. Этого времени достаточно, чтобы сделать памятные фотографии.
        </p>
        <p class="tips__text">
          После штурма можно совершить прогулку до ближайшего ледника — это займет около 20 минут. Если у группы остались силы и погодные условия благоприятны, маршрут можно продлить до знаменитых ледников Фюртванглера и Ройша. На это потребуется два-три часа. Решение о выходе к ледникам принимает главный гид исходя из состояния участников экспедиции и погоды.
        </p>
        <h3 class="tips__title">Умеренный темп восхождения на пути к вершине</h3>
        <p class="tips__text">
          В зоне вершины Килиманджаро концентрация молекул кислорода в воздухе примерно в два раза ниже, чем на уровне моря. Поэтому важно соблюдать умеренный темп: организм должен постепенно адаптироваться к высоте, сохраняя ресурс для жизнедеятельности в экстремальный условиях. Темп будут задавать гиды, учитывая ваш уровень подготовки.
        </p>
        <p class="tips__text">
          Во время подъема гиды будут делать остановки на 5–10 минут. Если вам потребуется отдыхать чаще или дольше, обязательно сообщите им об этом.
        </p>
        <h3 class="tips__title">Решения гида – окончательные</h3>
        <p class="tips__text">
          Основой всех экспедиций Altezza Travel является безопасность, и вся работа горной команды направлена на ее обеспечение. Поэтому мы наделяем гида правом прекратить восхождение и спустить участника экспедиции вниз в таких случаях:
        </p>
        <ul class="tips__list">
          <li>
            Темп восхождения слишком медленный и не позволит участнику экспедиции подняться на пик Ухуру до 11 часов утра. Если выйти к вершине позднее – не получится вернуться в лагерь до наступления темноты, а это существенный риск;
          </li>
          <li>
            У участника восхождения наблюдаются серьезные проблемы с акклиматизацией, а использование кислородной маски не помогает; уровень кислорода в крови не повышается или падает сразу же после использования маски;
          </li>
          <li>По любым другим медицинским причинам на усмотрение гида.</li>
        </ul>
        <p class="tips__text">
          Если во время вашей экспедиции возникнет подобная ситуация, просим с пониманием отнестись к этому решению. Самостоятельно оценить все риски в условиях разряженной атмосферы и сильной усталости бывает сложно, поэтому мы призываем довериться профессионализму и опыту наших гидов. Они провели сотни экспедиций и точно знают, как действовать правильно в таких обстоятельствах.
        </p>
        <p class="tips__text">
          Хотим подчеркнуть, что такие случаи крайне редки. Средний показатель успешных восхождений с Altezza Travel по всем маршрутам составляет 95%. В каждую экспедицию мы берем большой запас кислорода, проводим регулярные медосмотры и выбираем маршруты с хорошей программой акклиматизации. Эти меры значительно повышают шансы. Те участники, которые по каким-либо причинам прекращают восхождение, обычно принимают это решение сами.
        </p>
        <p class="tips__text">
          Тем не менее мы наделяем гидов правом самостоятельно принять решение о прекращении экспедиции, даже если участник не согласен. Мы убеждены в том, что жизнь и здоровье важнее нескольких тысяч долларов, потраченных на восхождение. Несмотря на то что гора Килиманджаро в целом безопасна для новичков, ежегодно здесь погибают несколько десятков людей. А благодаря нашим протоколам безопасности, в Altezza Travel — крупнейшем операторе на Килиманджаро — не было ни одного подобного случая.
        </p>
      </section>
      <section class="tips__section" id="section-19">
        <div class="tips__headline">
          <div class="tips__headline-picture">
            <img src="@/assets/img/tips/tips-descent.svg" alt="Descent">
          </div>
          <h2 class="tips__title">Спуск с вершины Килиманджаро</h2>
        </div>
        <p class="tips__text">
          Насладившись победой и сделав памятные фотографии у таблички «Поздравляем! Вы на пике Ухуру, 5 895 метров!», группа начнет спуск. На этом этапе важно быть особенно внимательными и не торопиться: из-за усталости и продолжительного воздействия высоты координация и реакция замедляются. Из-за этого можно легко споткнуться о камни и упасть.
        </p>
        <p class="tips__text">
          На спуске увеличивается нагрузка на колени и спину, поэтому рекомендуем использовать треккинговые палки. Они помогут равномерно распределить ее и поберечь суставы и позвоночник.
        </p>
        <p class="tips__text">
          Обратный путь с вершины до штурмового лагеря в среднем занимает два-три часа. Там вы отдохнете, пообедаете, а после начнете спуск в новый лагерь, в котором проведете последнюю ночь на Килиманджаро. Обычно туда приходят перед ужином. Лагерь расположен в живописном месте, так что советуем посвятить этот вечер прогулкам и общению с другими путешественниками.
        </p>
        <p class="tips__text">
          После завтрака группа отправится к выходу из парка. На выходе у вас состоится небольшая церемония вручения сертификатов и медалей. Затем вас отвезут в ваш отель, где менеджер Altezza Travel вернет личные вещи, которые вы сдали на хранение.
        </p>
        <div class="tips__video">
          <iframe
            srcdoc="<style>
            * {
              padding: 0;
              margin: 0;
              overflow: hidden;
            }

            body, html {
              height: 100%;
            }

            a {
              display: flex;
              height: 100%;
            }

            img {
              position: absolute;
              width: 100%;
              height: 100%;
              inset: 0;
            }

            svg {
              margin: auto;
              filter: drop-shadow(1px 1px 10px hsl(206.5, 70.7%, 8%));
              transition: all 0.25s ease-in-out;
            }

            body:hover svg {
              filter: drop-shadow(1px 1px 10px hsl(206.5, 0%, 10%));
              transform: scale(1.2);
            }
          </style>
          <a href='https://www.youtube.com/embed/UOnLl6926Tk?si=Z0F3397Vsu9U0sHB&autoplay=1&mute=1'>
            <img src='https://img.youtube.com/vi/UOnLl6926Tk/maxresdefault.jpg' alt='Preview'>
            <svg xmlns='http://www.w3.org/2000/svg' width='80' height='59' fill='none'><path fill='#fff' d='M21.332 8h36v42.667h-36z'/><path fill='#E60000' d='M78.13 9.985c-1.6-4.923-6.895-7.905-11.767-8.589a249.56 249.56 0 0 0-52.725 0C8.765 2.08 3.456 5.033 1.87 9.985a99.938 99.938 0 0 0 0 38.493c1.6 4.916 6.894 7.905 11.767 8.589a249.568 249.568 0 0 0 52.724 0c4.873-.684 10.182-3.637 11.767-8.59a99.937 99.937 0 0 0 0-38.492Zm-47.7 34.573v-30.66l24.958 15.33c-8.414 5.17-16.58 10.181-24.958 15.33Z'/></svg>
          </a>
        "
            class="tips__iframe"
            loading="lazy"
            src="https://www.youtube.com/embed/UOnLl6926Tk?si=Z0F3397Vsu9U0sHB"
            frameborder="0"
            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
            referrerpolicy="strict-origin-when-cross-origin"
            allowfullscreen
          ></iframe>
        </div>
        <h3 class="tips__title">Чаевые для горной команды</h3>
        <p class="tips__text">
          Если вам понравится сервис во время экспедиции, горной команде можно оставить чаевые.
        </p>
        <p class="tips__text">
          Для чаевых в Altezza Travel разработана особая процедура, связанная с нашим членством в организации KPAP. Она направлена на обеспечение прозрачности и справедливости: после спуска менеджер даст вам специальный конверт и форму, в которой нужно указать сколько чаевых вы оставляете. Сумму положите в конверт и отдайте менеджеру.
        </p>
        <p class="tips__text">
          Мы передадим конверт в бухгалтерию, которая переведет ваши чаевые гидам и портерам на личные счета. Все сопутствующие банковские комиссии оплатит наша компания.
        </p>
        <p class="tips__text">
          Подробнее можно почитать в нашей <a href="https://altezzatravel.ru/articles/tipping-culture" target="_blank">статье о чаевых для горной команды</a>.
        </p>
        <p class="tips__text">
          Средняя сумма чаевых – 250-300 долларов США с одного участника восхождения (принимаются только наличные купюрами крупного номинала, например 50-100 долларов), которые распределяются между членами вашей горной команды.
        </p>
        <div class="tips__note">
          <div class="tips__note-title">Обратите внимание</div>
          <p class="tips__note-text">
            Банки Танзании не принимают повреждённые купюры или доллары США, выпущенные до 2009 года. Пожалуйста, используйте только купюры номиналом 50 и 100 долларов США выпуска 2009 года и новее.
          </p>
          <p class="tips__note-text">
            Чаевые при оплате банковской картой или банковским переводом облагаются НДС 18% и дополнительной комиссией танзанийского банка (комиссия 3,5% при оплате картой или 60 долларов США при банковском переводе). Эти комиссии и НДС 18% будут добавлены к сумме чаевых, если вы выберете один из этих способов оплаты. Чтобы избежать дополнительных сборов, мы рекомендуем оставлять чаевые наличными.
          </p>
        </div>
      </section>
      <section class="tips__section tips__section--last" id="section-20">
        <div class="tips__headline">
          <div class="tips__headline-picture">
            <img src="@/assets/img/tips/tips-insurance.svg" alt="Insurance">
          </div>
          <h2 class="tips__title">Эвакуация и страховка</h2>
        </div>
        <p class="tips__text">
          Благодаря нашим протоколам безопасности в экспедициях Altezza Travel редко случаются эвакуации. В год таких случаев не более 50. Основные причины – сложности с акклиматизацией или травмы. Существует несколько вариантов экстренного спуска с Килиманджаро:
        </p>
        <p class="tips__text">
          <b>Пешком.</b> Это наиболее распространенный вариант. Если организм участника плохо акклиматизируется, он начинает обычный спуск в сопровождении нескольких гидов.
        </p>
        <p class="tips__text">
          <b>На носилках.</b> Используется, если из-за сильного приступа горной болезни или травмы человек не может самостоятельно идти. Однако, гиды Altezza Travel обучены диагностировать острое развитие горной болезни на ранних стадиях и не доведут до ситуации, когда участнику экспедиции понадобятся носилки. Тем не менее, мы всегда готовы к различным сценариям и члены горной команды владеют техникой спуска на носилках.
        </p>
        <div class="tips__note">
          <div class="tips__note-title">Возможности эвакуации автомобилем на Килиманджаро ограничены</div>
          <p class="tips__note-text">
            Эвакуация внедорожником возможно только из одного высотного лагеря – Хоромбо (3 720 метров над уровнем моря) на маршруте Марангу. По всем остальным маршрутам этот тип эвакуации доступен только на финальном отрезке маршрута, который можно пройти пешком за 30 минут. Эвакуационный автомобиль проезжает эту дистанцию за 10 минут. Таким образом, существенной разницы на скорость эвакуации по популярным маршрутам Лемошо, Мачаме и Марангу эвакуационный внедорожник не оказывает.
          </p>
        </div>
        <p class="tips__text">
          <b>Эвакуация вертолетом.</b> На сегодняшний день в Килиманджаро есть две компании, которые организуют эвакуации таким способом. Altezza Travel сотрудничает с обеими и при необходимости может оперативно спустить пострадавшего с высоты. Важно понимать ограничения, с которыми работают пилоты:
        </p>
        <ul class="tips__list">
          <li>
            Погодные условия: полет не состоится в случае сильных дождей, ветра или плохой видимости;
          </li>
          <li>
            Приоритетные эвакуации: в первую очередь вертолет вылетает туда, где есть угроза жизни пострадавшему;
          </li>
          <li>
            Высота: вертолеты не могут совершить посадку выше штурмовых лагерей Кибо и Барафу. Если чрезвычайная ситуация произошла в зоне вершины, сначала необходимо спустится к оборудованной площадке в указанных лагерях;
          </li>
          <li>
            Грузоподъемность: каждый вертолет может взять два-три участника экспедиции в зависимости от их веса. На борт не допускаются баулы с вещами. Их доставит команда сопровождения. Обычно на это уходит около 12 часов с момента эвакуации;
          </li>
          <li>
            Ночные эвакуации невозможны: в горных условиях вертолеты летают только в дневное время. Это общее правило безопасности полетов, которое соблюдается на всех горных вершинах мира.
          </li>
        </ul>
        <p class="tips__text">
          Если самочувствие человека не улучшается после эвакуации, менеджер  Altezza Travel отвозит его в госпиталь  . Доктора имеют большой опыт работы с осложнениями горной болезни и знают, как эффективно оказать помощь.
        </p>
        <h3 class="tips__title">Страховка для восхождения</h3>
        <p class="tips__text">
          Главным образом, страховка нужна, чтобы при необходимости покрыть расходы на вертолетную эвакуацию (от 3,500 долларов) и медицинскую помощь. Счет за спуск на вертолете нужно оплатить сразу после приземления*. Компания-организатор полета предоставит документы, необходимые для получения страхового возмещения.
        </p>
        <p class="tips__text">
          <b>Важно:</b> для получения страхового возмещения также требуется медицинский отчет от врача, поэтому после эвакуации необходимо обратиться в медицинское учреждение для осмотра и оформления соответствующих документов. В госпитале вас будет сопровождать наш менеджер, и мы также предоставим трансфер в отель после посещения врача.
        </p>
        <p class="tips__text">
          При оформлении страховки важно убедиться, что ваше покрытие распространяется на услуги вертолетной эвакуации в Танзании при занятии высокогорным трекингом на высоте 6 000 метров и выше. Обязательно уточните это у страховой компании.
        </p>
        <p class="tips__text">
          Аналогичный принцип применяется к получению возмещения за услуги медицинской помощи, незапланированного проживания в отеле или дополнительных трансферов, вызванных эвакуацией. Важно выбрать надежную компанию не для формального выполнения условий участия в экспедиции, а для того, чтобы в случае необходимости действительно получить компенсацию.
        </p>
        <p class="tips__text">
          Нашим путешественникам мы всегда рекомендуем Global Rescue. Компания не просто производит выплату возмещения: в партнерстве с Altezza Travel она занимаются организацией эвакуацией. Их команда поддержки отвечает быстро и подробно. За годы работы с Global Rescue нам не известен ни один случай неудачной эвакуации.
        </p>
        <p class="tips__text">
          *  Чтобы не платить за эвакуацию самому, рекомендуем оформить страховое покрытие у компании Global Rescue. Они сами закрывают все счета и берут на себя всю коммуникацию с компанией-организатором полетов и больницей. Оформить покрытие можно по <a href="https://partner.globalrescue.com/altezzatravel/" target="_blank">ссылке</a>.
        </p>
      </section>
      <div class="tips__footer">
        <h2 class="tips__title">Желаем вам успешного восхождения на Килиманджаро!</h2>
        <p>Если у вас будут дополнительные вопросы, свяжитесь со своим менеджером.</p>
        <div class="tips__footer-img">
          <img src="@/assets/img/tips/tips-footer.jpg" alt="Mount">
        </div>
        <h2 class="tips__title">Ждем вас в солнечной Танзании!</h2>
        <p>
          С <img src="@/assets/img/tips/tips-heart.svg" alt="Heart"> от Альтеза Тревел
        </p>
        <div class="tips__footer-contacts">
          <a href="mailto:office@altezza.travel" class="tips__footer-mail">office@altezza.travel</a>
          <a href="https://altezzatravel.com" class="tips__footer-link">www.altezzatravel.com</a>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { debounce } from 'lodash'

export default {
  name: 'Tips',
  data() {
    return {
      show_sidebar: false,
    }
  },
  mounted() {
    if (window.innerWidth > 900) {
      window.addEventListener('scroll', debounce(this.onHandleWindowScroll, 10))
    }
  },
  beforeDestroy() {
    if (window.innerWidth > 900) {
      window.removeEventListener('scroll', this.onHandleWindowScroll)
    }
  },
  methods: {
    onHandleWindowScroll() {
      document.querySelector('.tips__nav-list').classList.toggle('tips__nav-list--scroll', window.scrollY > 57)

      document.querySelectorAll('.tips__section').forEach(el => {
        if (el.offsetTop - 300 <= window.scrollY) {
          document.querySelectorAll('.tips__nav-link').forEach(link => {
            link.classList.toggle('tips__nav-link--active', link.getAttribute('href').replace('#', '') === el.id)
          })
        }
      })
    },
    onShowSidebar() {
      this.show_sidebar = !this.show_sidebar
    },
    onScrollToSection(id) {
      window.scrollTo({top: document.getElementById(id).offsetTop - 10, behavior: 'smooth'})
      if (window.innerWidth <= 900) {
        this.show_sidebar = false
      }
    },
  }
}
</script>

<style scoped lang="sass">
.tips__container
  position: relative
  display: flex
  background-image: url("~@/assets/img/tips/tips-bg.jpg")
  background-position: 330px bottom
  background-repeat: no-repeat
  background-size: calc(100% - 330px) 129px

  +max-w($laptop)
    background-position: left bottom
    background-size: 100% 129px

  +max-w($mobile_md)
    background-size: 150% 129px

  +max-w($mobile_sm)
    background-position: 50% bottom
    background-size: 200% 129px

.tips__side
  flex-shrink: 0
  position: absolute
  z-index: 2
  top: 57px
  width: 330px
  padding: 30px 30px 30px 40px
  height: calc(100% - 57px)
  border-right: 1px solid #ddd
  box-shadow: 0 1px 9px rgba(0, 0, 0, 0.06)
  background-color: #fff
  transition: transform 0.3s

  +max-w($laptop_md)
    padding: 30px 15px

  +max-w($laptop)
    top: 0
    height: 100%
    transform: translateX(-100%)

  +max-w($mobile_sm)
    width: 290px

.tips__side--show
  transform: translateX(0)

.tips__nav
  position: sticky
  top: 30px

.tips__side-title
  display: flex
  align-items: center
  gap: 10px
  margin-bottom: 20px
  color: #202020
  font-size: 15px
  font-weight: 600
  line-height: 1
  text-transform: uppercase

  +max-w($laptop_md)
    margin-bottom: 20px

.tips__nav-list
  scrollbar-color: $color-theme transparent
  scrollbar-width: thin
  overflow: hidden auto
  height: calc(100vh - 153px)
  transition: height 0.3s

  +max-w($laptop)
    height: calc(100vh - 96px)

  &::-webkit-scrollbar
    width: 2px

  &::-webkit-scrollbar-track
    border-radius: 5px
    background-color: #f2f3f8

  &::-webkit-scrollbar-thumb
    border-radius: 5px
    background-color: $color-theme

  li
    margin-bottom: 10px

    &:last-child
      margin-bottom: 0

.tips__nav-list--scroll
  height: calc(100vh - 96px)

.tips__nav-icon
  flex-shrink: 0
  display: flex
  align-items: center
  justify-content: center
  width: 25px
  height: 25px
  border-radius: 10px
  background-color: #ececec
  transition: background-color 0.3s ease-out

  img
    filter: invert(81%) sepia(0%) saturate(0%) hue-rotate(152deg) brightness(94%) contrast(85%)
    transition: filter 0.3s

  +max-w($laptop)
    background-color: $color-theme

    img
      filter: invert(100%) sepia(0%) saturate(4%) hue-rotate(126deg) brightness(104%) contrast(101%)

.tips__nav-link
  display: inline-flex
  align-items: center
  gap: 10px
  color: #696969
  font-size: 14px
  transition: color 0.3s

  &:active
    color: #202020

  @media (hover: hover)
    &:hover,
    &:focus-visible
      color: #202020

      .tips__nav-icon
        background-color: $color-theme

        img
          filter: invert(100%) sepia(0%) saturate(4%) hue-rotate(126deg) brightness(104%) contrast(101%)

.tips__nav-link--active
  color: #202020

  .tips__nav-icon
    background-color: $color-theme

    img
      filter: invert(100%) sepia(0%) saturate(4%) hue-rotate(126deg) brightness(104%) contrast(101%)

.tips__content
  flex-grow: 1
  position: relative
  max-width: 1114px
  padding: 83px 60px 150px 390px

  +max-w($laptop_md)
    padding: 80px 15px 120px 345px

  +max-w($laptop)
    padding: 80px 15px 120px 15px

.tips__title
  color: #202020
  font-weight: 600

  &:is(h1)
    font-size: 30px

    +max-w($laptop)
      font-size: 24px

  &:is(h2)
    font-size: 23px

    +max-w($laptop)
      font-size: 18px

  &:is(h3)
    margin-bottom: 20px
    font-size: 20px

    +max-w($laptop)
      font-size: 17px

.tips__title--mb
  margin-bottom: 7px

.tips__title--center
  text-align: center

.tips__head
  display: flex
  align-items: center
  justify-content: space-between
  margin-bottom: 20px
  padding-bottom: 13px
  border-bottom: 1px solid #ececec

  span
    color: #202020
    font-size: 18px
    font-weight: 500

    +max-w($laptop)
      font-size: 16px

.tips__wish
  align-items: center
  margin-bottom: 30px
  padding: 18px 26px
  border-radius: 12px
  color: #202020
  background-color: #f5f5f5
  font-size: 15px
  font-weight: 500
  line-height: 22px

  +max-w($laptop)
    margin-bottom: 20px
    padding: 10px 15px
    font-size: 14px

  img
    margin-bottom: -5px

.tips__section
  margin-bottom: 40px
  padding-bottom: 30px
  border-bottom: 1px solid #ececec

  +max-w($laptop)
    margin-bottom: 20px
    padding-bottom: 20px

.tips__section--last
  border-bottom: none
  margin-bottom: 50px
  padding-bottom: 0

  +max-w($laptop)
    margin-bottom: 30px

.tips__headline
  display: flex
  align-items: center
  gap: 20px
  margin-bottom: 20px

  +max-w($laptop)
    margin-bottom: 15px

.tips__headline-picture
  display: flex
  align-items: center
  width: 37px
  height: 30px
  border-right: 1px solid #cacaca

.tips__text
  margin-bottom: 20px
  color: #000
  font-size: 14px
  line-height: 1.6

  &:last-child
    margin-bottom: 0

  +max-w($laptop)
    margin-bottom: 10px

  b
    color: #000
    font-weight: 500

  i
    font-size: 13px
    font-weight: 300
    font-style: italic

  a
    display: inline-flex
    flex-direction: column
    color: #000
    font-weight: 500

    @media (hover: hover)
      &:hover,
      &:focus-visible
        &:after
          opacity: 0

    &:after
      content: ''
      height: 3px
      border-radius: 3px
      background-color: rgba(119, 176, 23, 0.50)
      opacity: 1
      transform: translateY(-2px)
      transition: opacity 0.3s

.tips__note
  margin-bottom: 25px
  padding: 24px 30px
  border-left: 3px solid #77b017
  border-radius: 0 10px 10px 0
  box-shadow: 0 1px 9px rgba(0, 0, 0, 0.06)
  background-color: #f2f4ee

  &:last-child
    margin-bottom: 0

  +max-w($laptop)
    margin-bottom: 10px
    padding: 10px 15px

.tips__note-title
  margin-bottom: 15px
  color: #191f0f
  font-size: 14px
  font-weight: 500

  +max-w($laptop)
    margin-bottom: 8px

.tips__note-text
  margin-bottom: 15px
  color: #191f0f
  font-size: 14px
  line-height: 1.6

  &:last-child
    margin-bottom: 0

  b
    color: #191f0f
    font-weight: 500

  a
    display: inline-flex
    flex-direction: column
    color: #191f0f
    font-weight: 500

    @media (hover: hover)
      &:hover,
      &:focus-visible
        &:after
          opacity: 0

    &:after
      content: ''
      height: 3px
      border-radius: 3px
      background-color: rgba(119, 176, 23, 0.50)
      opacity: 1
      transform: translateY(-2px)
      transition: opacity 0.3s

.tips__list
  margin-bottom: 25px
  padding-left: 22px

  &:is(ul)
    list-style-type: disc

  &:is(ol)
    list-style-type: decimal

  &:last-child
    margin-bottom: 0

  li
    margin-bottom: 5px
    color: #000
    font-size: 14px
    line-height: 1.6

    &:last-child
      margin-bottom: 0

    b
      color: #000
      font-weight: 500

.tips__subt
  display: flex
  align-items: center
  gap: 7px
  margin-bottom: 10px
  color: #202020
  font-size: 14px
  line-height: 1.7
  font-weight: 600
  text-transform: uppercase

.tips__underline
  text-decoration: underline

.tips__burger
  position: fixed
  right: 15px
  width: 46px
  height: 46px
  border-radius: 50%
  background-color: #f5f5f5
  background-image: url("~@/assets/img/tips/tips-burger.svg")
  background-position: center
  background-repeat: no-repeat
  z-index: 2

  +min-w($laptop)
    display: none

.tips__video
  position: relative
  margin-bottom: 30px
  aspect-ratio: 1.77
  border-radius: 10px
  overflow: hidden

  &:last-child
    margin-bottom: 0

.tips__thumbnail
    position: absolute
    inset: 0
    width: 100%
    height: 100%
    z-index: 10
    object-fit: cover

.tips__iframe
  position: absolute
  inset: 0
  width: 100%
  height: 100%
  z-index: 1

.tips__gear
  display: flex
  align-items: flex-end
  gap: 24px
  margin-bottom: 30px
  padding: 25px
  border-radius: 14px
  background-image: linear-gradient(212deg, #163950 37.58%, #347196 117.08%)
  box-shadow: 0 1px 9px 0 rgba(0, 0, 0, 0.10)

  +max-w($mobile_md)
    flex-direction: column
    align-items: flex-start
    gap: 15px
    padding: 15px

.tips__gear-img
  position: relative
  flex-shrink: 0
  width: 177px
  height: 200px
  background-image: url("~@/assets/img/tips/tips-gear-man.png")
  background-size: cover
  background-repeat: no-repeat

  &:before
    content: ''
    position: absolute
    background-image: url("~@/assets/img/tips/tips-gear-packing.svg")
    background-size: cover
    left: -11px
    bottom: 0
    width: 138px
    height: 44px

.tips__gear-content
  display: flex
  flex-direction: column

.tips__gear-title
  margin-bottom: 12px
  color: #fff
  font-size: 23px
  font-weight: 600
  line-height: 1.2
  letter-spacing: -0.46px

  +max-w($mobile_md)
    margin-bottom: 10px
    font-size: 18px

.tips__gear-text
  margin-bottom: 28px
  color: #fff
  font-size: 14px
  line-height: 1.5

  +max-w($mobile_md)
    margin-bottom: 15px

.tips__gear-link
  display: flex
  align-items: center
  justify-content: center
  width: 230px
  height: 48px
  border-radius: 10px
  color: #fff
  background-color: #68a522
  font-size: 14px
  font-weight: 600
  background-image: url("~@/assets/img/tips/tips-gear-download.svg")
  background-size: 16px
  background-repeat: no-repeat
  background-position: 35px center
  transition: background-color 0.3s

  @media (hover: hover)
    &:hover,
    &:focus-visible
      background-color: $color-theme

.tips__footer
  text-align: center

  h2
    margin-bottom: 15px
    color: #202020

  p
    margin-bottom: 30px
    color: #202020
    font-size: 15px
    font-weight: 500

    +max-w($laptop)
      margin-bottom: 20px

    img
      margin: 0 5px -7px

.tips__footer-img
  position: relative
  width: 100%
  margin-bottom: 30px
  aspect-ratio: 3.161
  border-radius: 10px
  overflow: hidden

  +max-w($laptop)
    margin-bottom: 20px

  img
    position: absolute
    inset: 0
    width: 100%
    height: 100%
    object-fit: cover

.tips__footer-contacts
  display: flex
  flex-direction: column
  align-items: center
  gap: 15px

  a
    font-size: 15px
    color: $color-theme
    transition: color 0.3s, border-color 0.3s

.tips__footer-mail
  @media (hover: hover)
    &:hover,
    &:focus-visible
      color: #68a522

.tips__footer-link
  border-bottom: 1px solid $color-theme

  @media (hover: hover)
    &:hover,
    &:focus-visible
      border-color: transparent
</style>
